var React = require('react');

function Sync (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M10 17a6 6 0 0 1-6-6c0-1 .25-1.97.7-2.8L3.24 6.74A7.93 7.93 0 0 0 2 11a8 8 0 0 0 8 8v3l4-4-4-4m0-11V0L6 4l4 4V5a6 6 0 0 1 6 6c0 1-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 18 11a8 8 0 0 0-8-8z"}));
}

Sync.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"0 0 20 22","width":"20px","height":"22px"};

module.exports = Sync;

Sync.default = Sync;
